import {Fragment, ReactNode} from 'react'
import {useSessionCookie} from "../../hooks/useSessionCookie";
import {Navigate} from 'react-router-dom'
import React from 'react'
import {appRoute, productionMode} from "../../utils/routes";

interface AuthGuardProps {
    children: ReactNode
    reverseAuth?: boolean
}

const AuthGuard = (props: AuthGuardProps) => {
    const {userSession} = useSessionCookie()

    if (props.reverseAuth) {
        if (userSession)
            return <Navigate to={appRoute()}/>
        else
            return <Fragment>{props.children}</Fragment>
    } else if (!userSession)
        return <Navigate to={productionMode ? '/login' : '/'}/>
    else
        return <Fragment>{props.children}</Fragment>
}

export default AuthGuard